// @flow
import React, { Component } from 'react';
import UserDetailsProvider from './components/UserDetailsProvider';
import LocationsContextProvider from './components/LocationsContextProvider';
import ThemeProvider from './components/ThemeProvider';
import NotificationProvider from './components/NotificationProvider';
import LoadingProvider from './components/LoadingProvider.component';
import { Route, Switch } from 'react-router';
import { Layout } from './components/Layout';
import UserProfile from './components/UserProfile';
import Locations from './components/Locations';
import AddDevice from './components/AddDevice';
import ManageLocations from './components/ManageLocations';
import ManageGroups from './components/ManageGroups';
import ManageUsers from './components/ManageUsers';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import AssignDeviceToGroup from './components/AssignDeviceToGroup';
import Invitation from './components/Invitation';
import Login from './components/Login';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPowerOff, faAngleUp, faAngleDown, faPlusSquare, faUserCircle, faBell, faAngleDoubleDown, faAngleDoubleUp, faToggleOff, faToggleOn, faUser, faKey, faEnvelope, faTrashAlt, faPlusCircle, faMinusCircle, faEdit, faObjectUngroup, faLayerGroup, faUsers, faCog, faCogs, faSync, faDownload, faSignOutAlt, faShareAlt, faCopy } from '@fortawesome/free-solid-svg-icons';


library.add(faPowerOff, faAngleUp, faAngleDown, faPlusSquare, faUserCircle, faBell, faAngleDoubleDown, faAngleDoubleUp, faToggleOff, faToggleOn, faUser, faKey, faEnvelope, faTrashAlt, faPlusCircle, faMinusCircle, faEdit, faObjectUngroup, faLayerGroup, faUsers, faCog, faCogs, faSync, faDownload, faSignOutAlt, faShareAlt, faCopy);


export default class App extends Component {
    displayName = App.name

    render() {
        return (
            <LoadingProvider>
                <UserDetailsProvider>
                    <LocationsContextProvider>
                        <ThemeProvider>
                            <NotificationProvider>
                                <Layout>
                                    <Switch>
                                        {// PrivateRoutes can only be accessed when logged in (otherwise the user is redirected to /login):
                                        }
                                        <PrivateRoute exact path='/profile' component={UserProfile} />
                                        <PrivateRoute exact path='/addDevice' component={AddDevice} />
                                        <PrivateRoute exact path='/locations' component={ManageLocations} />
                                        <PrivateRoute exact path='/groups' component={ManageGroups} />
                                        <PrivateRoute exact path='/assignDeviceToGroup' component={AssignDeviceToGroup} />
                                        <PrivateRoute exact path='/manageUsers' component={ManageUsers} />

                                        {// PublicRoutes can only be accessed when NOT logged in (otherwise the user is redirected to /)
                                        }
                                            <PublicRoute exact path='/login' component={Login} />
                                            <PublicRoute exact path='/register' component={Register} />
                                            <PublicRoute exact path='/forgot-password' component={ForgotPassword} />
                                            <PublicRoute exact path='/reset-password' component={ResetPassword} />

                                        {// "Normal" routes can be accessed either when logged in, or when not logged in:
                                        }
                                        <Route exact path='/invitation' component={Invitation} />

                                        {// Default route (for any non-matching URL; server-side urlRewrite supports this):
                                        }
                                        <PrivateRoute component={Locations} />
                                    </Switch>
                                </Layout>
                            </NotificationProvider>
                        </ThemeProvider>
                    </LocationsContextProvider>
                </UserDetailsProvider>
            </LoadingProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js